import React, { useRef } from "react";
import { Link } from "@nextui-org/link";
import ScrollSpy from "react-ui-scrollspy";
import { button as buttonStyles } from "@nextui-org/theme";
import { Listbox, ListboxItem } from "@nextui-org/listbox";
import { Divider } from "@nextui-org/divider";

const termsSideMenu = [
  {
    id: 1,
    url: "intro",
    title: "Introduction",
  },
  {
    id: 2,
    url: "property",
    title: "Intellectual Property",
  },
  {
    id: 3,
    url: "reg",
    title: "User Obligations",
  },

  {
    id: 4,
    url: "risk",
    title: "Risk Acknowledgment",
  },
  {
    id: 5,
    url: "compliance",
    title: "Compliance with Laws",
  },
  {
    id: 6,
    url: "law",
    title: "Governing Law & Jurisdiction",
  },
];

const TermSpyCom = () => {
  const parentScrollContainerRef = useRef(null);
  const onPress = (key: any) => {
    const target = window.document.getElementById(key);

    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="container lg:px-16 xl:px-16 md:px-16 px-2 pb-28">
      <div className="flex flex-row justify-center flex-wrap mt-[80px]">
        <div className="lg:w-1/4 xl:w-1/4 w-full self-start p-3 sm:p-2 relative mb-8 lg:sticky lg:top-10">
          <div className="relative">
            <Listbox
              aria-label="PolicyList"
              className="p-0 gap-4 divide-y divide-default-300/50 dark:divide-default-100/80 bg-content1 overflow-visible shadow-small rounded-medium"
              itemClasses={{
                base: "px-3 py-4 first:rounded-t-medium last:rounded-b-medium rounded-none gap-3 h-12 data-[hover=true]:bg-default-100/80",
              }}
              items={termsSideMenu}
              selectionMode="single"
              variant="flat"
              onAction={(key) => onPress(key)}
            >
              {(item) => <ListboxItem key={item.url}>{item.title}</ListboxItem>}
            </Listbox>
          </div>
        </div>
        <div className="lg:w-3/4 xl:w-3/4 w-full">
          <div className="ct-bg-white flex flex-col justify-center items-center lg:mx-8 my-0 rounded-md">
            <div className="ct-faint-bg ct-sm-margin rounded-md">
              <div ref={parentScrollContainerRef} className="p-4">
                <ScrollSpy scrollThrottle={100} useBoxMethod={false}>
                  <div className="py-6" id="intro">
                    <h1 className="text-3xl lg:text-6lg tracking-tight inline font-semibold">
                      Introduction
                    </h1>
                    <div className="mt-5 gap-4">
                      <p className="text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        Welcome to CryptoTX, the forefront of financial
                        innovation. <br />
                        In a world where the boundaries of trade and commerce
                        are expanding, we bring you a service that transcends
                        traditional banking limitations. <br />
                        CryptoTX is not just a platform; it's a gateway to
                        global financial freedom.
                      </p>
                      <p className="text-md pt-7 lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        These Terms apply fully to your use of this Website.
                        By using this Website, you agree to accept all terms
                        and conditions written herein. You must not use this
                        Website if you disagree with any of these Standard
                        Terms and Conditions.
                      </p>
                      <p className="text-md pt-7 lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        Minors or people below 18 years old are not allowed to
                        use this Website.
                      </p>
                    </div>
                  </div>
                  <Divider className="my-8" />
                  <div className="py-6" id="property">
                    <h2 className="text-3xl lg:text-6lg tracking-tight inline font-semibold">
                      Intellectual Property Rights
                    </h2>
                    <div className="mt-5 gap-4">
                      <p className="text-md pb-8 lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        All intellectual property associated with us, including
                        but not limited to the website, platform interface,
                        content, processes, software, trademarks, logos, and
                        brand elements, are the exclusive property of CryptoTX
                        or its licensors. Users acknowledge that CryptoTX is the
                        owner or licensee of all rights to the intellectual
                        property and agree not to challenge the validity of our
                        intellectual property.{" "}
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Use of Service
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTX grants users a limited, non-exclusive,
                        non-transferable, and revocable license to access and
                        use the services provided by CryptoTX strictly in
                        accordance with these Terms and Conditions. This license
                        does not include any rights to resell the services,
                        create derivative works, or utilize the service for
                        unauthorized commercial purposes.
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Prohibited Actions
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        Users are prohibited from copying, modifying,
                        distributing, selling, or leasing any part of CryptoTx's
                        services or included software, nor may users reverse
                        engineer or attempt to extract the source code of the
                        software, except to the extent laws prohibit these
                        restrictions.{" "}
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        {" "}
                        Protection of Intellectual Property
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTX actively protects its intellectual property
                        rights to the fullest extent of the law. Users agree to
                        cooperate with CryptoTX in protecting such rights and to
                        report any suspected infringement of these rights
                        immediately.
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Intellectual Property Claims
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        If CryptoTX receives a claim alleging that the service
                        infringes or violates the rights of a third party, we
                        we reserve the right to suspend or terminate the user's
                        access to the service without notice. CryptoTX will also
                        have the discretion to modify the service to avoid any
                        further alleged infringement.
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Indemnification
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        Users agree to indemnify and hold harmless CryptoTX from
                        any claims, damages, liabilities, costs, and expenses
                        (including reasonable attorneys' fees) arising from any
                        use of the service that infringes upon the intellectual
                        property rights of CryptoTX or any third party.
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        {" "}
                        Amendments to Intellectual Property
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTX reserves the right to make changes to the
                        intellectual property, services, and any associated
                        materials at any time without notice, subject to the
                        terms outlined in these Terms and Conditions.
                      </p>
                    </div>
                  </div>

                  <Divider className="my-8" />

                  <div className="py-6" id="reg">
                    <h3 className="text-3xl lg:text-6lg tracking-tight inline font-semibold">
                      User Obligations
                    </h3>
                    <p className="text-md pt-5 pb-5 lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                      Users must comply with all applicable laws, regulations,
                      and guidelines related to cryptocurrency transactions.
                      This includes adhering to anti-money laundering (AML) and
                      combating the financing of terrorism (CFT) laws, as well
                      as any other financial services regulations.
                    </p>

                    <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                      Accurate Information
                    </h5>
                    <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                      Users are required to provide accurate and current
                      information when creating an account and conducting
                      transactions. Any changes to personal or financial
                      information must be updated promptly.
                    </p>
                    <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                      Security
                    </h5>
                    <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-fullr">
                      Users are responsible for maintaining the confidentiality
                      of their account credentials, including passwords and any
                      other means of accessing their account. Users must notify
                      CryptoTx immediately of any unauthorized use of their
                      account.
                    </p>
                    <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                      Prohibited Use
                    </h5>
                    <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                      Users may not use CryptoTX services for any illegal or
                      unauthorized purpose, including but not limited to money
                      laundering, terrorist financing, fraud, or any other
                      activities prohibited by law.
                    </p>
                    <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                      Reporting Obligations
                    </h5>
                    <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                      Users must report any suspicious activities or
                      transactions that they encounter on the CryptoTX platform
                      in accordance with the platform's reporting procedures.
                    </p>
                    <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                      {" "}
                      Cooperation with Investigations
                    </h5>
                    <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                      Users agree to cooperate fully with any investigations
                      conducted by CryptoTX or any regulatory or governmental
                      authority regarding their use of the services.
                    </p>
                    <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                      Limitations on Use
                    </h5>
                    <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                      CryptoTX reserves the right to limit, suspend, or
                      terminate a user's access to the services if they violate
                      these obligations or engage in activities that are
                      detrimental to CryptoTx or its users.
                    </p>
                    <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                      Indemnification
                    </h5>
                    <p className="pt-4 pb-5 text-md lg:text-lg xl:text-lg text-default-600 font-medium block max-w-full">
                      Users agree to indemnify and hold harmless CryptoTx, its
                      affiliates, officers, agents, and employees from any claim
                      or demand made by any third party due to or arising out of
                      the user's breach of these obligations, or the user's
                      violation of any law or the rights of a third party.
                    </p>
                  </div>

                  <Divider className="my-8" />

                  <div className="py-6" id="risk">
                    <h4 className="text-3xl lg:text-6lg tracking-tight inline font-semibold">
                      {" "}
                      Risk Acknowledgment
                    </h4>
                    <div className="mt-5 gap-4">
                      <p className="text-md pb-5 lg:text-lg text-default-600 font-medium block max-w-full">
                        By using CryptoTX services, users acknowledge that they
                        understand the inherent risks associated with
                        cryptocurrency transactions. These risks include, but
                        are not limited to, market volatility, regulatory
                        changes, and potential cybersecurity threats.
                      </p>
                      <p className="text-md pb-5 lg:text-lg text-default-600 font-medium block max-w-full">
                        Users recognize that the cryptocurrency market is highly
                        volatile and that the value of USDT can fluctuate
                        significantly within short periods. Users accept the
                        risk of loss due to such volatility.
                      </p>
                      <p className="text-md pb-5 lg:text-lg text-default-600 font-medium block max-w-full">
                        Users are aware that the regulatory environment for
                        cryptocurrency is evolving and that changes in laws or
                        regulations may impact the use of our services.
                      </p>
                      <p className="text-md pb-5 lg:text-lg text-default-600 font-medium block max-w-full">
                        While we employ robust security measures, users
                        acknowledge that no system can be completely immune to
                        breaches or failures. Users agree that CryptoTX is not
                        liable for any unauthorized access to their accounts
                        that is beyond the control of CryptoTX.
                      </p>
                      <p className="text-md pb-5 lg:text-lg text-default-600 font-medium block max-w-full">
                        Users are responsible for determining any tax
                        implications of their cryptocurrency transactions.
                        CryptoTX does not provide tax advice and users
                        acknowledge their obligation to report and pay taxes
                        according to the laws of their jurisdiction.
                      </p>
                      <p className="text-md pb-5 lg:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTX strives to provide continuous service, but
                        users acknowledge that interruptions may occur for
                        reasons such as maintenance, upgrades, or external
                        factors beyond CryptoTX's control.
                      </p>
                      <p className="text-md pb-5 lg:text-lg text-default-600 font-medium block max-w-full">
                        Users accept full responsibility for all transactions
                        conducted through their CryptoTX account and agree to
                        monitor their transactions and balances diligently.
                      </p>
                      <p className="text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        Users agree to indemnify and hold harmless CryptoTX from
                        any claims, damages, or losses resulting from their
                        failure to acknowledge or understand the risks
                        associated with using CryptoTX services.
                      </p>
                    </div>
                  </div>

                  <Divider className="my-8" />

                  <div className="py-6" id="compliance">
                    <h3 className="text-3xl lg:text-6lg tracking-tight inline font-semibold">
                      Compliance with Laws
                    </h3>
                    <div className="mt-5 gap-4">
                      <p className="text-md pb-5 lg:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTX operates in strict adherence to the legal and
                        regulatory requirements governing financial services and
                        cryptocurrency transactions. Users must ensure that all
                        transactions comply with the laws of their respective
                        jurisdictions, as well as international financial
                        regulations.
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Regulatory Adherence
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        Users are responsible for understanding and complying
                        with all applicable laws, including but not limited to
                        anti-money laundering (AML), combating the financing of
                        terrorism (CFT), and any other relevant financial
                        services legislation.
                      </p>
                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Reporting and Transparency
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTx is committed to maintaining a transparent
                        financial environment. Users must report accurate
                        transaction information and cooperate with any
                        regulatory inquiries or audits.
                      </p>
                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Changes in Law
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        Users acknowledge that changes in law or regulation may
                        affect the availability and functionality of CryptoTx
                        services. Users agree to promptly adapt to such changes
                        and continue to comply with all legal requirements.
                      </p>
                      <h3 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Limitation of Liability
                      </h3>
                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTX's liability to users shall be limited to the
                        maximum extent permitted by law. This section outlines
                        the scope and extent of our liability to you.
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Financial Caps
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTX's liability for any claims arising out of or
                        related to the use of its services will be limited to
                        the amount you have paid to CryptoTX for its services,
                        if any.
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        {" "}
                        Exclusion of Indirect Damages
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        In no event will CryptoTX be liable for any indirect,
                        special, incidental, consequential, or punitive damages,
                        including but not limited to loss of profits, data, or
                        use, whether in an action in contract or tort, arising
                        out of or in any way connected with the use of or
                        inability to use the services provided by CryptoTX.
                      </p>

                      <h5 className="text-xl lg:text-4lg tracking-tight inline font-semibold">
                        Force Majeure
                      </h5>
                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTx will not be liable for any failure or delay in
                        performance due to circumstances beyond its reasonable
                        control, including but not limited to acts of God, war,
                        terrorism, riots, embargoes, acts of civil or military
                        authorities, fire, floods, accidents, network
                        infrastructure failures, strikes, or shortages of
                        transportation facilities, fuel, energy, labor, or
                        materials.
                      </p>
                    </div>
                  </div>

                  <Divider className="my-8" />

                  <div className="py-6" id="law">
                    <h3 className="text-3xl lg:text-6lg tracking-tight inline font-semibold">
                      Governing Law & Jurisdiction
                    </h3>
                    <div className="mt-5 gap-4">
                      <p className="pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        The laws of the jurisdiction where CryptoTx is
                        headquartered will govern the dispute resolution
                        process. The outcome of the arbitration will be final
                        and binding on all parties, and they may enter the
                        judgment on the arbitration award in any court having
                        jurisdiction.
                      </p>

                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTx reserves the right to amend these Terms and
                        Conditions at any time to reflect changes in the law,
                        changes to our services, or for any other reason deemed
                        necessary by CryptoTx.
                      </p>

                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        Users will be notified of any amendments through our
                        website or via email to the address associated with
                        their account.
                      </p>

                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        Amendments will be effective immediately upon posting
                        for new users and will become effective for existing
                        users 30 days after posting, unless otherwise stated.
                      </p>

                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        CryptoTx is committed to resolving disputes in a fair,
                        efficient, and cost-effective manner. The following
                        dispute resolution process is designed to address any
                        disagreements that may arise.
                      </p>

                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        Before pursuing any formal proceedings, parties agree to
                        attempt to resolve the dispute through good faith
                        negotiations within 30 days from the date of the dispute
                        notification.
                      </p>

                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        If negotiations do not resolve the dispute, parties
                        agree to engage in mediation with a mutually agreed-upon
                        mediator to facilitate a resolution. Should mediation
                        fail, the dispute will be resolved by binding
                        arbitration. The arbitration will be conducted in
                        accordance with the rules of a recognized arbitration
                        association and will take place in the jurisdiction
                        where CryptoTX is located
                      </p>

                      <p className="pt-4 pb-5 text-md lg:text-lg text-default-600 font-medium block max-w-full">
                        For further information, contact us at{" "}
                      </p>

                      <Link
                        className={buttonStyles({
                          color: "primary",
                          radius: "md",
                          size: "lg",
                          variant: "shadow",
                        })}
                        href="/contact-us"
                      >
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </ScrollSpy>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermSpyCom;
